import React from 'react'
import { t } from 'ttag'

import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { updateSelectedFilters } from 'store/actions/filters'
import Button from 'components/ui/Button'
import FilterTitle from 'components/ui/FilterTitle'
import SearchFilter from 'components/ui/SearchFilter'
import SelectedFilter from 'components/ui/SelectedFilter'
import FilterText from 'components/ui/FilterText'
import RemoveIcon from 'components/ui/RemoveIcon'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import { SELECTED_FILTER_MAX_LINES } from 'store/constants/constants'
import Dotdotdot from 'react-dotdotdot'
import CustomDropDownTreeSelect from 'components/ui/CustomDropdownTreeSelect'

function DocumentTypes({ type, filterData, values, title, onClose, showFilter, customTop }) {
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters
  const filterObject = filters.selectedFilters[currentSearchable][type]
  return (
    <PureDocumentTypes
      type={type}
      filterData={filterData}
      values={values}
      title={title}
      onClose={onClose}
      showFilter={showFilter}
      customTop={customTop}
      filterObject={filterObject}
    />
  )
}

const PureDocumentTypes = React.memo(function PureDocumentTypes({
  type,
  filterData,
  values,
  title,
  onClose,
  showFilter,
  customTop,
  filterObject
}) {
  const dispatch = useDispatch()

  const selectedValues = filterObject[values[0]]
  const options = filterData
    ? filterData.map(option => {
        const parentOption = {
          label: option.title,
          value: option.name,
          expanded: true
        }
        const selectedOption = selectedValues.filter(s => s === option.name)
        if (selectedOption.length > 0) {
          parentOption.checked = true
        }
        return parentOption
      })
    : []

  const onChange = (currentNode, selectedNodes) => {
    const filterValue = selectedNodes.map(node => node.value)

    const data = {
      filterType: type,
      filterId: values[0],
      filterValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function handleFilterRemove(filterId, filterValue, valueIsArray = false) {
    let resultingValue = null
    if (valueIsArray) {
      resultingValue = filterObject[filterId].filter(
        s => s.id !== filterValue.id || s !== filterValue
      )
    }
    const data = {
      filterType: type,
      filterId,
      filterValue: resultingValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function renderSelectedValues() {
    return values.map(value => {
      if (filterObject[value]) {
        const filterValue = filterObject[value]
        if (filterValue instanceof Array) {
          return filterValue.map(v => {
            const filterTitle = filterData.filter(option => option.name === v)[0].title
            return (
              <SelectedFilterContainer className="selected-filters" key={filterTitle}>
                <SelectedFilter>
                  <FilterText title={filterTitle}>
                    <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>{filterTitle}</Dotdotdot>
                  </FilterText>
                  <RemoveIcon
                    className="far fa-times"
                    onClick={() => handleFilterRemove(value, v, true)}
                  />
                </SelectedFilter>
              </SelectedFilterContainer>
            )
          })
        }
      }
      return false
    })
  }

  return (
    <>
      <SearchFilter open={showFilter} customTop={customTop}>
        <FilterTitle>{title}</FilterTitle>

        <CustomDropDownTreeSelect data={options} onChange={onChange} />

        <Button size="medium" onClick={onClose}>
          {t`Close`}
        </Button>
      </SearchFilter>
      <div>{renderSelectedValues()}</div>
    </>
  )
})

DocumentTypes.propTypes = {
  type: PropTypes.string,
  filterData: PropTypes.array,
  values: PropTypes.array,
  title: PropTypes.string,
  onClose: PropTypes.func,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string
}

PureDocumentTypes.propTypes = {
  type: PropTypes.string,
  filterData: PropTypes.array,
  values: PropTypes.array,
  title: PropTypes.string,
  onClose: PropTypes.func,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string,
  filterObject: PropTypes.object
}

export default DocumentTypes
